module.exports = __webpack_public_path__ + "img/digitalticket_number_big.d6118189.svg";